import EventSource from 'eventsource';

export const ADD_EVENT_SOURCE = 'ADD_EVENT_SOURCE';
export const REMOVE_EVENT_SOURCE = 'REMOVE_EVENT_SOURCE';

export interface AddEventSource {
  type: typeof ADD_EVENT_SOURCE;
  payload: {
    url: string;
    onMessage: EventSource['onmessage'];
    onOpen?: EventSource['onopen'];
    onError?: EventSource['onerror'];
  };
}

export interface RemoveEventSource {
  type: typeof REMOVE_EVENT_SOURCE;
  payload: string;
}

export type EventSourceActionTypes = AddEventSource | RemoveEventSource;
